import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import { useThemeStore } from './stores/themeStore'
import { Toaster } from './components/ui/toaster'
import './utils/resetData' // Import reset utility for development
import ErrorBoundary from './components/ErrorBoundary'
import NavigationHelper from './components/NavigationHelper'
import AppRoutes from './components/AppRoutes'

function App() {
  const { isAuthenticated, initializeAuth } = useAuthStore()
  const { initializeTheme } = useThemeStore()
  const setBrandColors = useThemeStore((state) => state.setBrandColors)
  const companyDetails = useAuthStore((state) => state.companyDetails)
  const navigate = useNavigate()

  // Theme the app with the company's brand colours (from getmycompanydetails).
  // Runs before paint; when there is no company / no colours (e.g. logged out), the default blue theme applies.
  React.useLayoutEffect(() => {
    setBrandColors({ primary: companyDetails?.color_code, secondary: companyDetails?.secondary_color })
  }, [companyDetails?.color_code, companyDetails?.secondary_color, setBrandColors])

  // Initialize theme and auth on app start
  React.useEffect(() => {
    initializeTheme()
    initializeAuth()
  }, [])

  // Handle 401 responses from the API interceptor gracefully via React Router
  // instead of a hard browser redirect, so ProtectedLayout handles the redirect.
  React.useEffect(() => {
    const handleUnauthorized = () => {
      useAuthStore.getState().logout()
      navigate('/auth/login', { replace: true })
    }
    window.addEventListener('auth:unauthorized', handleUnauthorized)
    return () => window.removeEventListener('auth:unauthorized', handleUnauthorized)
  }, [navigate])

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-white">
        <AppRoutes />
        {/* <NavigationHelper /> */}
        <Toaster />
      </div>
    </ErrorBoundary>
  )
}

export default App